export const META = {
  favicon: "/favicon.ico",
  theme: "#FFFFFF",
  fbapp: "236717644287641",
  title: "Pency - Tu tienda online",
  description: "Ahorrá tiempo y dinero aceptando pedidos online con Pency",
  appleicon: "/logo192.jpg",
  keywords: "tienda, online, fácil, delivery, compra, venta",
  author: "Pency",
  twitter: "@pencyapp",
  url: "https://pency.app",
  banner: {
    url: "/og-image.jpg",
    format: "image/jpeg",
    width: "1200",
    height: "630",
  },
};
